import React, { useState } from "react";
import "./Add_Money.css";
import { Form, InputGroup } from "react-bootstrap";
import Green_Btn from "../../../common_components/common_btn/green_btn/Green_Btn";
import Success_Modal from "../../../common_components/common_modal/success_modal/Success_Modal";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  getAllWalletHistory,
  postAddMoney,
} from "../../../../features/wallet/walletSlice";
import useRazorpay from "react-razorpay";

const Add_Money = ({ walletHistory }) => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    register,
    setValue,
    watch,
    reset,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
    },
  });

  const amount = watch("amount");

  const presetAmounts = [500, 1000, 1500, 2000];

  const handlePresetClick = (value) => {
    clearErrors();
    setValue("amount", value.toString());
  };

  const [razorid, setRazorId] = useState();
  const dispatch = useDispatch();
  const finalFunction = async (d, razorid) => {
    const data = {
      transaction_id: razorid,
      amount: d.amount,
      description: "add money",
      transaction_type: "credit",
    };
    const res = await dispatch(postAddMoney({ data }));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      reset();

      await dispatch(getAllWalletHistory());
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (data) => {
    const amountInPaise = data.amount * 100;
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Groscido",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(data, res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  return (
    <section className="Add_Money">
      <div className="available_balance_div">
        <div className="left_side">
          <p className="rupees">
            ₹{" "}
            {walletHistory?.user_wallet?.amount !== undefined
              ? Number(walletHistory.user_wallet.amount).toFixed(2)
              : "0.00"}
          </p>
          <p className="balance">Available Balance</p>
        </div>
        <div className="img_holder">
          <img src="/assets/images/wallet/wallet.png" className="img" />
        </div>
      </div>

      <div className="gray_holder">
        <div className="form">
          <Form>
            <Form.Group className="input_group">
              <Form.Label>Add Money to Wallet</Form.Label>
              <InputGroup size="sm">
                <InputGroup.Text id="inputGroup-sizing-sm">₹</InputGroup.Text>
                <Form.Control
                  {...register("amount", {
                    required: "Enter Amount",
                    validate: (value) =>
                      parseFloat(value) > 0 || "Amount must be greater than 0",
                  })}
                  aria-label="Small"
                  placeholder="Enter Amount"
                  type="text"
                  aria-describedby="inputGroup-sizing-sm"
                  onKeyDown={(e) => {
                    if (
                      !(
                        (e.key >= "0" && e.key <= "9") || // allow digits
                        e.key === "Backspace" ||
                        e.key === "Delete" ||
                        e.key === "ArrowLeft" ||
                        e.key === "ArrowRight" ||
                        e.key === "Tab"
                      )
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </InputGroup>
            </Form.Group>
            {errors.amount && (
              <span className="text-danger">{errors.amount.message}</span>
            )}

            <div className="row">
              {presetAmounts.map((val, index) => (
                <div className="col-6" key={val}>
                  <div
                    className={`rs_holder ${
                      amount === val.toString() ? "active" : ""
                    }`}
                    onClick={() => handlePresetClick(val)}
                    style={{ cursor: "pointer" }}
                  >
                    <p className="rs_text">₹ {val}</p>
                    <div className="absolute_div">
                      <p className="inner_text">Popular</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="row">
              <div className="col-6">
                <div className="rs_holder active">
                  <p className="rs_text">₹ 500</p>
                  <div className="absolute_div">
                    <p className="inner_text">Popular</p>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="rs_holder ">
                  <p className="rs_text">₹ 1000</p>
                  <div className="absolute_div">
                    <p className="inner_text">Popular</p>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="rs_holder ">
                  <p className="rs_text">₹ 1500</p>
                  <div className="absolute_div">
                    <p className="inner_text">Popular</p>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="rs_holder ">
                  <p className="rs_text">₹ 2000</p>
                  <div className="absolute_div">
                    <p className="inner_text">Popular</p>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="btn_holder">
              <Green_Btn
                btn_name="Add Balance"
                onClick={handleSubmit(handleRazorpay)}
                // onClick={() => {
                //   setShowSucsessModal(true);
                // }}
              />
            </div>
          </Form>
        </div>
      </div>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Amount added successfully!"
      />
    </section>
  );
};

export default Add_Money;
